import type { IValidatedResponse } from '../../httpClient';
import { postRequest } from '../../httpClient';
import type { IRecordAttributionV2Body } from './record-attribution-v2-request';
import type { IRecordAttributionV2Response } from './record-attribution-v2-response';
import { recordAttributionV2ResponseSchema } from './record-attribution-v2-response';

export async function recordAttributionV2Api(
  body: IRecordAttributionV2Body,
): Promise<IValidatedResponse<IRecordAttributionV2Response>> {
  return postRequest<IRecordAttributionV2Response>({
    path: '/account/attribution/v2',
    body,
    schema: recordAttributionV2ResponseSchema,
  });
}
